import React from 'react'
import { Outlet } from 'react-router-dom'

function ResendPasswordOutlet() {
  return <Outlet />
}

export default ResendPasswordOutlet
